import { render, staticRenderFns } from "./forehead.vue?vue&type=template&id=e9ea8ee2"
import script from "./forehead.vue?vue&type=script&lang=js"
export * from "./forehead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports